import React, { useState, useEffect } from 'react';
import { useSelector} from 'react-redux';
import Form from '../../../../../Form/Form'
import CModal from '../../../../../Form/CModal'
import { Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import notEmpty from '../../../../../../FormValidation/notEmpty';
import noWhiteSpace from '../../../../../../FormValidation/noWhiteSpace';
import { addTaxPricing, editTaxPricing } from '../../../../../../utils';
import maxTextField from '../../../../../../FormValidation/maxTextField';
import positive from '../../../../../../FormValidation/positive';


const useStyles = makeStyles((theme) => ({
    formContainer: {
        border: '20px',
        backgroundColor: 'white',
        borderRadius: '4px',
        padding: "20px",
        maxWidth: "600px",
        width: "100%",
        maxHeight: "80vh",
        overflowY: "auto"
    }
}))

const TaxForm = (props) => {
    const businessId = useSelector((state) => { return (state.buisnessDetails.businessId) });
    const classes = useStyles()
    const refresh = (success) => {
        if (success) {
            props.setOpen(false)
            props.refresh()
        }
    }

    return (
        <CModal open={props.open} setOpen={props.setOpen}>
            <Container component="main" className={classes.formContainer}>
                <Form
                    moreData={{ businessId: businessId, optionId: props.optionDetails.optionId, taxLineId: (props.edit?props.open.taxLineId:null) }}
                    title={`${(props.edit?"Edit":"Add")} Tax`}
                    cancelEnabled
                    cancelAction={() => { props.setOpen(false) }}
                    submitText={(props.edit?"Edit":"Add")}
                    action={(props.edit?editTaxPricing:addTaxPricing)}
                    postAction={refresh}
                    inputFields={[
                        {
                            type: "TextField",
                            name: "name",
                            label: "Tax Name",
                            validator: [notEmpty, noWhiteSpace, maxTextField],
                            initialvalue: (props.edit?props.open.name:null)
                        },

                        {
                            type: "Percent",
                            label: "Percent",
                            name: "percentage",
                            initialvalue: (props.edit?props.open.percentage:null),
                            validator: [positive, value=>value>100?"Maximum of 100%":null]
                        },
                    ]}
                />
            </Container>
        </CModal>
    );
};

export default TaxForm